import { fontSMStyle, panelBaseStyle } from '@blocksuite/hive-shared/styles';
import { css } from 'lit';

const editLinkStyle = css`
  .hive-link-edit-popover {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: repeat(2, 1fr);
    grid-template-areas:
      'text-area .'
      'link-area btn';
    justify-items: center;
    align-items: center;
    width: 320px;
    gap: 8px 12px;
    padding: 8px;
    box-sizing: content-box;
  }

  ${fontSMStyle('.hive-link-edit-popover label')}
  .hive-link-edit-popover label {
    box-sizing: border-box;
    color: var(--hive-icon-color);
    font-weight: 400;
  }

  ${fontSMStyle('.hive-link-edit-popover input')}
  .hive-link-edit-popover input {
    color: inherit;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--hive-text-primary-color);
  }
  .hive-link-edit-popover input::placeholder {
    color: var(--hive-placeholder-color);
  }
  input:focus {
    outline: none;
  }
  .hive-link-edit-popover input:focus ~ label,
  .hive-link-edit-popover input:active ~ label {
    color: var(--hive-primary-color);
  }

  .hive-edit-area {
    width: 280px;
    padding: 4px 10px;
    display: grid;
    gap: 8px;
    grid-template-columns: 26px auto;
    grid-template-rows: repeat(1, 1fr);
    grid-template-areas: 'label input';
    user-select: none;
    box-sizing: border-box;

    border: 1px solid var(--hive-border-color);
    box-sizing: border-box;

    outline: none;
    border-radius: 4px;
    background: transparent;
  }
  .hive-edit-area:focus-within {
    border-color: var(--hive-blue-700);
    box-shadow: var(--hive-active-shadow);
  }

  .hive-edit-area.text {
    grid-area: text-area;
  }

  .hive-edit-area.link {
    grid-area: link-area;
  }

  .hive-edit-label {
    grid-area: label;
  }

  .hive-edit-input {
    grid-area: input;
  }

  .hive-confirm-button {
    grid-area: btn;
    user-select: none;
  }
`;

export const linkPopupStyle = css`
  :host {
    box-sizing: border-box;
  }

  .mock-selection {
    position: absolute;
    background-color: rgba(35, 131, 226, 0.28);
  }

  ${panelBaseStyle('.popover-container')}
  .popover-container {
    z-index: var(--hive-z-index-popover);
    animation: hive-popover-fade-in 0.2s ease;
    position: absolute;
  }

  @keyframes hive-popover-fade-in {
    from {
      opacity: 0;
      transform: translateY(-3px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .overlay-root {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: var(--hive-z-index-popover);
  }

  .mock-selection-container {
    pointer-events: none;
  }

  .hive-link-popover.create {
    display: flex;
    gap: 12px;
    padding: 8px;

    color: var(--hive-text-primary-color);
  }

  .hive-link-popover-input {
    min-width: 280px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 10px;
    background: var(--hive-white-10);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: var(--hive-border-color);
    color: var(--hive-text-primary-color);
  }
  ${fontSMStyle('.hive-link-popover-input')}
  .hive-link-popover-input::placeholder {
    color: var(--hive-placeholder-color);
  }
  .hive-link-popover-input:focus {
    border-color: var(--hive-blue-700);
    box-shadow: var(--hive-active-shadow);
  }

  ${editLinkStyle}
`;
